var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { active: _vm.menuOpened }, attrs: { id: "menu-toggler" } },
    [
      _c(
        "div",
        {
          staticClass: "stripes",
          on: {
            click: function($event) {
              _vm.menuOpened = !_vm.menuOpened
            }
          }
        },
        [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: { active: _vm.menuOpened }, attrs: { id: "nav-menu" } },
        [_vm._m(0)]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", [
      _c(
        "a",
        { attrs: { target: "_blank", href: "https://youtu.be/y_N0gt4eONI" } },
        [_vm._v("如何使用")]
      ),
      _vm._v(" "),
      _c("a", { attrs: { href: "./related_sites.html" } }, [
        _vm._v("相關網站")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "./references.html" } }, [_vm._v("資料來源")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "./contact.html" } }, [_vm._v("聯絡我們")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }